import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
    changeCamPosition,
    changeImageKey,
    changeLevel,
    ifloorplanStateAdd,
    nextStep,
    setColor,
    setColorBackground,
    setColorText
} from '../redux/actions/actions';
import EditButtonLabel from './EditButtonLabel';

const CustomButtons = (props) => {
    const buttonMarkerObj = props.image_key >=0 ? props.ifloorplanNowState.level[props.levelNowId].images[props.image_key] :
                props.ifloorplanNowState.level[props.levelNowId].panelum[props.pannellum_key];
    const [buttonLabel, setButtonLabel] = useState('button')
    const [colorBg, setColorBg] = useState('#bfbfbf')
    const [butWidth, setButWidth] = useState(10)
    const [butHeight, setButHeight] = useState(5)
    const [butRounding, setButRounding] = useState(2)
    const [butScale, setButScale] = useState(1)
    const [labelStyle, setLabelStyle] = useState()

    useEffect(() => {
        if (buttonMarkerObj) {
            setButtonLabel(buttonMarkerObj.button_label);
            setColorBg(buttonMarkerObj.button_bg ? buttonMarkerObj.button_bg : '#bfbfbf');
            setButWidth(buttonMarkerObj.button_width);
            setButHeight(buttonMarkerObj.button_height);
            setButRounding(buttonMarkerObj.button_radius);
            setButScale(buttonMarkerObj.button_scale);
            setLabelStyle({
                fontWeight: buttonMarkerObj.button_font_weight,
                fontStyle: buttonMarkerObj.button_font_style,
                fontSize: `${buttonMarkerObj.button_font_size}vh`,
                fontFamily: buttonMarkerObj.button_font_family,
                color: buttonMarkerObj.button_color_text,
            })
        }
    }, [])

    // Pressing the button 'Swap Marker for a button'/'Swap with active marker' changes the marker to the button
    useEffect(() => {
        const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        if (!buttonMarkerObj) return;
        if (props.swapMarkButt) {
            if (props.image_key >= 0) {
                newState.level[props.levelNowId].images[props.image_key].button = true;
                newState.level[props.levelNowId].images[props.image_key].button_label = buttonLabel;
                newState.level[props.levelNowId].images[props.image_key].button_bg = colorBg;
                newState.level[props.levelNowId].images[props.image_key].button_color_text = buttonMarkerObj.button_color_text ? buttonMarkerObj.button_color_text : '#000';
            }
            else if (props.pannellum_key >= 0) {
                newState.level[props.levelNowId].panelum[props.pannellum_key].button = true;
                newState.level[props.levelNowId].panelum[props.pannellum_key].button_label = buttonLabel;
                newState.level[props.levelNowId].panelum[props.pannellum_key].button_bg = colorBg;
                newState.level[props.levelNowId].panelum[props.pannellum_key].button_color_text = buttonMarkerObj.button_color_text ? buttonMarkerObj.button_color_text : '#000';
            }
        } else {
            if (props.image_key >=0)
                newState.level[props.levelNowId].images[props.image_key].button = false;
            else if (props.pannellum_key >= 0)
                newState.level[props.levelNowId].panelum[props.pannellum_key].button = false;
        }
        props.ifloorplanStateAdd(newState)
    }, [props.swapMarkButt])

    useEffect(() => {
        if (!buttonMarkerObj) return;
        setButtonLabel(buttonMarkerObj.button_label);
        setLabelStyle({
            fontWeight: buttonMarkerObj.button_font_weight,
            fontStyle: buttonMarkerObj.button_font_style,
            fontSize: `${buttonMarkerObj.button_font_size}vh`,
            fontFamily: buttonMarkerObj.button_font_family,
            color: buttonMarkerObj.button_color_text ? buttonMarkerObj.button_color_text : '#000',
        })
    },[props.ifloorplanNowState])

    return (
        <div className='customButtons' style={{display: props.display}}>
            <div className="customButtons__example">
                <button className="customButtons__example_btn"
                        style={{
                            ...labelStyle,
                            backgroundColor: colorBg,
                            width: `${butWidth}vh`,
                            height: `${butHeight}vh`,
                            borderRadius: butRounding + 'rem',
                        }}>
                    {buttonLabel}
                </button>
            </div>
            <div className="selectButton__label">
                <h3>Label</h3>
                <EditButtonLabel/>
            </div>
            <div className="scale-wrapper color">
                <h3>Colour</h3>
                <input type="color"
                    onChange={(e) => {
                        setColorBg(e.target.value);
                        const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                        if (props.image_key >= 0) newState.level[props.levelNowId].images[props.image_key].button_bg = e.target.value;
                        else if (props.pannellum_key >= 0) newState.level[props.levelNowId].panelum[props.pannellum_key].button_bg = e.target.value;
                        props.ifloorplanStateAdd(newState)
                    }}/>
            </div>
            <div className="scale-wrapper">
                <h3>Width</h3>
                <input type="range"
                       id='buttonSize'
                       step="0.5"
                       className="scale-image"
                       min="8"
                       max="20"
                       value={butWidth}
                       onChange={(event) => {
                           setButWidth(event.target.value)
                           const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                           if (props.image_key >= 0) newState.level[props.levelNowId].images[props.image_key].button_width = event.target.value;
                           else if (props.pannellum_key >= 0) newState.level[props.levelNowId].panelum[props.pannellum_key].button_width = event.target.value;
                           props.ifloorplanStateAdd(newState)
                       }}/>
            </div>
            <div className="scale-wrapper">
                <h3>Height</h3>
                <input type="range"
                       id='buttonSize'
                       step="0.5"
                       className="scale-image"
                       min="3"
                       max="10"
                       value={butHeight}
                       onChange={(event) => {
                           setButHeight(event.target.value)
                           const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                           if (props.image_key >= 0) newState.level[props.levelNowId].images[props.image_key].button_height = event.target.value;
                           else if (props.pannellum_key >= 0) newState.level[props.levelNowId].panelum[props.pannellum_key].button_height = event.target.value;
                           props.ifloorplanStateAdd(newState)
                       }}/>
            </div>
            <div className="scale-wrapper">
                <h3>Rounding</h3>
                <input type="range"
                       id='buttonSize'
                       step="0.05"
                       className="scale-image"
                       min="0.5"
                       max="4.1"
                       value={butRounding}
                       onChange={(event) => {
                           setButRounding(event.target.value)
                           const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                           if (props.image_key >= 0) newState.level[props.levelNowId].images[props.image_key].button_radius = event.target.value;
                           else if (props.pannellum_key >= 0) newState.level[props.levelNowId].panelum[props.pannellum_key].button_radius = event.target.value;
                           props.ifloorplanStateAdd(newState)
                       }}/>
            </div>
            <div className="scale-wrapper">
                <h3>Scale</h3>
                <input type="range"
                       id='buttonSize'
                       step="0.05"
                       className="scale-image"
                       min="0.5"
                       max="3"
                       value={butScale}
                       onChange={(event) => {
                           setButScale(event.target.value)
                           const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                           if (props.image_key >= 0) newState.level[props.levelNowId].images[props.image_key].button_scale = event.target.value;
                           else if (props.pannellum_key >= 0) newState.level[props.levelNowId].panelum[props.pannellum_key].button_scale = event.target.value;
                           props.ifloorplanStateAdd(newState)
                       }}/>
            </div>
            <button className='chooseMarkButt'
                            onClick={() => {
                                props.setSwapMarkButt(!props.swapMarkButt)
                            }}>
                        {props.swapMarkButt
                            ?
                            'Swap button for a Marker'
                            :
                            'Swap this button for active Marker'
                        }
            </button>
            <div className="return-marker-editor-button"
                onClick={() => {
                    props.setMarkersButtons(markersButtons => !markersButtons);
                }}>
                {"< Replace all markers"}
            </div>
        </div>
    )
}

const putState = (state) => {
    return {
        step: state.step,
        levelNowId: state.levelNowId,
        cam_key: state.cam_key,
        image_key: state.image_key,
        positionCams: state.positionCams,
        ifloorplanNowState: state.ifloorplanNowState,
        text_color: state.text_color,
        background_color: state.background_color,
        set_color: state.set_color,
        pannellum_key: state.pannellum_key,
    }
}
const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        changeCamKey: (key) => dispatch(changeCamKey(key)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        changeCamPosition: (obj) => dispatch(changeCamPosition(obj)),
        setColor: (bool) => dispatch(setColor(bool)),
        changeLevel: (level) => dispatch(changeLevel(level)),
        changeImageKey: (key) => dispatch(changeImageKey(key)),
        setColorBackground: (color) => dispatch(setColorBackground(color)),
        setColorText: (color) => dispatch(setColorText(color))
    }
}
export default connect(putState, putActions)(CustomButtons);